<div class="home-layout">
  <!-- SIDE NAV (keep yours) -->
  <aside class="side-nav" appSkipperHideDuringShow>
    <app-side-navigation></app-side-navigation>
  </aside>

  <!-- MAP AREA -->
  <section class="map-wrapper">
    <!-- MAP -->
    <div id="map" [appTourAnchor]="'home.mapArea'"
      [style.pointer-events]="isWaypointManagerOpen ? 'none' : 'auto'"></div>

    <!-- CHART LOADING — shown after a highlight/focus jump into an area whose
         tiles have not downloaded yet, so the momentarily bare chart reads as
         "loading" rather than as a broken map. Non-blocking by design: the pin
         is already on screen and the user can keep interacting. -->
    <div class="chart-loading-pill" *ngIf="isChartLoading" role="status" aria-live="polite">
      <span class="chart-loading-spinner" aria-hidden="true"></span>
      <span class="chart-loading-text">Loading chart…</span>
    </div>

    <!-- Tour-only spotlight target at the map centre. After "Center Me" or a
         waypoint save the chart re-centres on the position, so the live marker /
         new waypoint sits here — the My Location and Create Waypoint tours
         spotlight this small box instead of the whole map. -->
    <div class="tour-map-center" [appTourAnchor]="'home.mapCenter'" aria-hidden="true"></div>

    <!-- ── Combo overlay (SST / Chlorophyll / Wind / Salinity / Currents / FSLE) ── -->
    <!-- Screen-space arrows (wind forecast + surface currents) -->
    <app-combo-wind-arrows
      *ngIf="comboControlsVisible && (comboState.config.layer === 'wind' || comboState.config.layer === 'cur')"
      [map]="comboMap">
    </app-combo-wind-arrows>

    <!-- Floating control surface -->
    <!-- One stack for whichever layer is live: its card (player or heat controls), then the switcher
         that lists every layer. Marker layers have no card, so the switcher is what stays up. -->
    <div class="combo-card-anchor layer-stack" *ngIf="layerStackVisible" appSkipperHideDuringShow>
      <app-combo-slider-card
        *ngIf="comboControlsVisible"
        (closeCombo)="onComboClose()"
        (autoView)="onComboAutoView()"
        (openModels)="onComboOpenModels()">
      </app-combo-slider-card>
      <app-catch-heat-controls *ngIf="activeLayerKey === 'catch'"></app-catch-heat-controls>
      <app-map-layer-switcher></app-map-layer-switcher>
    </div>

    <!-- Probe readout bubble -->
    <app-combo-cursor-bubble
      *ngIf="comboControlsVisible && comboState.probe && comboProbeAnchor"
      [anchor]="comboProbeAnchor"
      (closeBubble)="combo.clearProbe()"
      (openModels)="onComboOpenModels()">
    </app-combo-cursor-bubble>

    <!-- Watermark Overlay (map screen only) -->
    <div
      *ngIf="showWatermark && !isProfileOpen && !isFilterOpen && !isLayerOpen &&!isWaypointCreating && !isWatchOpen && !isReplayMode && !isWaypointManagerOpen"
      class="watermark-overlay">
      <div class="watermark-container">
        <div *ngFor="let item of watermarkArray" class="watermark-text">
          {{ watermarkEmail }}
        </div>
      </div>
    </div>
    <!-- MOBILE FLOATING TOP BAR (search left, profile right) — hidden when profile is open -->
    <div class="mobile-top-bar" *ngIf="!isProfileOpen && !isMessagesOpen" appSkipperHideDuringShow>
      <button class="mobile-top-btn" (click)="onSearch()" aria-label="Search">
        <img src="/assets/home/shared/search_icon.svg" alt="Search" />
      </button>
      <button class="mobile-top-btn profile-btn" (click)="openUserProfile()" aria-label="Profile">
        <img src="/assets/home/shared/profile_logo.svg" alt="Profile" />
      </button>
    </div>

    <!-- CUSTOM MAP CONTROLS -->
    <div class="map-controls" *ngIf="!isProfileOpen && !isMessagesOpen" appSkipperHideDuringShow>
      <!-- SKIPPER: what is on this screen -->
      <app-skipper-help-button variant="glass" [size]="52"></app-skipper-help-button>

      <!-- MEASURE DISTANCE -->
      <button class="tool-btn tool-btn--circular" [appTourAnchor]="'home.measureIcon'"
        [class.tool-btn--active]="isMeasurementMode"
        (click)="toggleMeasurementMode()" title="Measure Distance" aria-label="Measure Distance">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
          [attr.stroke]="isMeasurementMode ? '#ffffff' : '#475466'" stroke-width="2" stroke-linecap="square"
          stroke-linejoin="miter">
          <rect x="1" y="10" width="22" height="8" rx="1" />
          <line x1="4.5" y1="10" x2="4.5" y2="13.5" />
          <line x1="7.5" y1="10" x2="7.5" y2="13.5" />
          <line x1="10.5" y1="10" x2="10.5" y2="13.5" />
          <line x1="13.5" y1="10" x2="13.5" y2="13.5" />
          <line x1="16.5" y1="10" x2="16.5" y2="13.5" />
          <line x1="19.5" y1="10" x2="19.5" y2="13.5" />
        </svg>
      </button>


      <!-- ZOOM IN -->
      <button class="tool-btn tool-btn--circular desktop-only" (click)="zoomIn()" aria-label="Zoom In">
        <span style="font-size: 18px; font-weight: 500; color: #475466;">+</span>
      </button>

      <!-- ZOOM OUT -->
      <button class="tool-btn tool-btn--circular desktop-only" (click)="zoomOut()" aria-label="Zoom Out">
        <span style="font-size: 18px; font-weight: 500; color: #475466;">−</span>
      </button>

      <!-- SIGNAL / WATCH -->
      <button class="tool-btn tool-btn--circular badge" (click)="openWatchPage()" *ngIf="!isFilterOpen"
        aria-label="Watch">
        <img src="/assets/home/shared/watch_logo.svg" alt="Watch" />
      </button>

      <!-- LOCATION / CENTER ME -->
      <button class="tool-btn tool-btn--circular" [appTourAnchor]="'home.myLocationButton'"
        (click)="goToCurrentLocation()" aria-label="Center Me"
        title="Center Me">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
          stroke="#475466" stroke-width="1.8" stroke-linecap="round">
          <circle cx="12" cy="12" r="7" />
          <circle cx="12" cy="12" r="2" fill="#475466" stroke="none" />
          <line x1="12" y1="2" x2="12" y2="5" />
          <line x1="12" y1="19" x2="12" y2="22" />
          <line x1="2" y1="12" x2="5" y2="12" />
          <line x1="19" y1="12" x2="22" y2="12" />
        </svg>
      </button>

    </div>

    <!-- ── REPLAY OVERLAY ── positioned bottom-left, above map controls -->
    <div class="replay-overlay-anchor" *ngIf="isReplayMode">
      <app-replay-overlay [initialPresetIndex]="_replayPresetIndex" [initialSourceIndex]="_replaySourceIndex"
        [initialCustomRange]="_replayCustomRange" (closed)="exitReplay()"
        (filterChanged)="onReplayFilterChanged($event)">
      </app-replay-overlay>
    </div>

    <!-- ── REPLAY EMPTY SNACKBAR ── -->
    <div class="replay-empty-toast"
      *ngIf="isReplayMode && replayState && replayState.lastLoadWasEmpty && !replayState.isLoading">
      No trips found for the selected filters.
    </div>

    <!-- UNIFIED MEASURE PILL — visible throughout measurement mode -->
    <div class="measure-pill" *ngIf="isMeasurementMode || measureDistance">
      <!-- Ruler icon -->
      <svg class="measure-pill-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
        fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="square" stroke-linejoin="miter">
        <rect x="1" y="10" width="22" height="8" rx="1" />
        <line x1="4.5" y1="10" x2="4.5" y2="13.5" />
        <line x1="7.5" y1="10" x2="7.5" y2="13.5" />
        <line x1="10.5" y1="10" x2="10.5" y2="13.5" />
        <line x1="13.5" y1="10" x2="13.5" y2="13.5" />
        <line x1="16.5" y1="10" x2="16.5" y2="13.5" />
        <line x1="19.5" y1="10" x2="19.5" y2="13.5" />
      </svg>

      <!-- Dynamic text -->
      <span class="measure-pill-text" *ngIf="measureDistance">{{ measureDistance }}</span>
      <span class="measure-pill-text" *ngIf="!measureDistance && !measurePointASet">Tap a point on the map</span>
      <span class="measure-pill-text" *ngIf="!measureDistance && measurePointASet">Tap a second point</span>

      <!-- Close / X button -->
      <button class="measure-pill-close" [appTourAnchor]="'filters.measureClose'" (click)="clearMeasurement()" aria-label="Clear measurement">
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
          stroke="rgba(255,255,255,0.9)" stroke-width="2.5" stroke-linecap="round">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>



    <!-- DOCKMATE BOAT CARD — placed next to the marker by positionDockmateCard() -->
    <div class="dockmate-detail-card" *ngIf="isDockmateCardOpen && dockmateCardParams && dockmateCardContext">
      <app-vessel-card
        [params]="dockmateCardParams"
        [identity]="dockmateCardContext.identity"
        [units]="dockmateCardContext.units"
        [chatEnabled]="dockmateCardContext.chatEnabled"
        (closed)="closeDockmateCard()"
        (participantsRequested)="openVesselCardParticipants($event)"
        (profileRequested)="openVesselCardProfile($event)"
        (chatRequested)="onDockmateCardChat($event)">
      </app-vessel-card>
    </div>

    <section class="buoy-detail-screen" *ngIf="isBuoyDetailOpen" (click)="closeBuoyDetailScreen()">
      <div class="buoy-detail-card" (click)="$event.stopPropagation()">
        <div class="buoy-detail-header">
          <div class="buoy-detail-icon-wrap">
            <img src="/assets/home/layer/buoy_marker.png" alt="Buoy">
          </div>
          <div class="buoy-detail-title-wrap">
            <h3>{{ selectedBuoy?.name || 'BUOY' }}</h3>
            <p>{{ selectedBuoy?.subtitle || '--' }}</p>
          </div>
          <button class="buoy-detail-close" (click)="closeBuoyDetailScreen()" aria-label="Close buoy details">
            <svg viewBox="0 0 24 24" width="15" height="15" fill="currentColor" aria-hidden="true"><path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
          </button>
        </div>

        <div class="buoy-detail-body">
          <ng-container *ngIf="!buoyDetailLoading; else buoyCurrentLoading">
            <div class="buoy-observation-block">
              <div class="buoy-metrics-grid" *ngIf="selectedBuoy?.currentObservation as currentObservation">
                <article class="buoy-metric-card" *ngFor="let metric of currentObservation.metricCards">
                  <span class="buoy-metric-label">{{ metric.label }}</span>
                  <span class="buoy-metric-value">
                    <img class="buoy-metric-icon" [src]="metric.iconSrc" [alt]="metric.iconAlt">
                    <span>{{ metric.value }}</span>
                  </span>
                </article>
              </div>
              <div class="buoy-observation-time">{{ selectedBuoy?.currentObservation?.timestampLabel || '--' }}</div>
            </div>
          </ng-container>

          <ng-template #buoyCurrentLoading>
            <div class="buoy-detail-loading">Loading latest observation...</div>
          </ng-template>

          <ng-container *ngIf="buoyHistoryExpanded">
            <h4 class="buoy-history-heading">PREVIOUS OBSERVATIONS</h4>
            <div class="buoy-observation-block" *ngFor="let pastObservation of buoyHistoryObservations">
              <div class="buoy-observation-time buoy-observation-time--top">{{ pastObservation.timestampLabel }}</div>
              <div class="buoy-metrics-grid">
                <article class="buoy-metric-card" *ngFor="let metric of pastObservation.metricCards">
                  <span class="buoy-metric-label">{{ metric.label }}</span>
                  <span class="buoy-metric-value">
                    <img class="buoy-metric-icon" [src]="metric.iconSrc" [alt]="metric.iconAlt">
                    <span>{{ metric.value }}</span>
                  </span>
                </article>
              </div>
            </div>
          </ng-container>

          <div class="buoy-show-more-wrap" *ngIf="!buoyHistoryExpanded">
            <button class="buoy-show-more-btn" (click)="loadBuoyHistory()" [disabled]="buoyHistoryLoading">
              {{ buoyHistoryLoading ? 'Loading...' : 'Show More' }}
            </button>
          </div>
        </div>
      </div>
    </section>

    <section class="tide-detail-screen" *ngIf="isTideDetailOpen">
      <div class="tide-detail-card">

        <div class="tide-detail-header">
          <div class="tide-detail-brand" aria-hidden="true">
            <svg class="tide-detail-waves" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2 14c2.5 0 2.5-4 5-4s2.5 4 5 4 2.5-4 5-4 2.5 4 5 4" stroke="white" stroke-width="2"
                stroke-linecap="round" />
              <path d="M2 10c2.5 0 2.5-4 5-4s2.5 4 5 4 2.5-4 5-4 2.5 4 5 4" stroke="white" stroke-width="2"
                stroke-linecap="round" opacity="0.9" />
              <path d="M2 18c2.5 0 2.5-4 5-4s2.5 4 5 4 2.5-4 5-4 2.5 4 5 4" stroke="white" stroke-width="2"
                stroke-linecap="round" opacity="0.75" />
            </svg>
          </div>
          <div class="tide-detail-title-wrap">
            <h3>{{ selectedTide?.name || 'Tide Station' }}</h3>
            <p>{{ selectedTide?.subtitle || '--' }}</p>
          </div>
          <button class="tide-detail-close" type="button" (click)="closeTideDetailScreen()"
            aria-label="Close tide details">✕</button>
        </div>

        <div class="tide-detail-body tide-detail-body--scroll">
          <ng-container *ngIf="tideDetailLoading">
            <div class="tide-loading-wrap">
              <div class="tide-loading-spinner" aria-hidden="true"></div>
            </div>
          </ng-container>

          <ng-container *ngIf="!tideDetailLoading && tideSheetError">
            <p class="tide-sheet-error">{{ tideSheetError }}</p>
          </ng-container>

          <ng-container *ngIf="!tideDetailLoading && !tideSheetError">
            <div class="tide-water-tile"
              *ngIf="selectedTide?.currentLevel !== null && selectedTide?.currentLevel !== undefined">
              <div class="tide-water-tile-accent" aria-hidden="true"></div>
              <div class="tide-water-tile-copy">
                <div class="tide-water-label">Water Level</div>
                <div class="tide-water-value-row">
                  <span class="tide-water-value">{{ selectedTide!.currentLevel | number:'1.2-2' }}</span>
                  <span class="tide-water-unit">ft</span>
                  <span class="tide-trend" *ngIf="tideTrendLabel()" [ngClass]="tideTrendClass()">{{ tideTrendLabel()
                    }}</span>
                </div>
              </div>
            </div>

            <ng-container *ngIf="selectedTide?.events?.length">
              <div class="tide-detail-meta tide-detail-meta--section">Today's Tides · {{ selectedTide?.dateLabel }}
              </div>
              <article class="tide-pred-row" *ngFor="let event of selectedTide!.events">
                <span class="tide-pred-arrow" [class.tide-pred-arrow--high]="event.type === 'High'">
                  {{ event.type === 'High' ? '↑' : '↓' }}
                </span>
                <span class="tide-pred-type">{{ event.type }}</span>
                <span class="tide-pred-spacer"></span>
                <span class="tide-pred-level">{{ event.level }}</span>
                <span class="tide-pred-time">{{ event.timeLabel }}</span>
              </article>
            </ng-container>
          </ng-container>

          <p class="tide-level-footer" *ngIf="!tideDetailLoading && !tideSheetError && tideLevelFooterDisplay()">
            {{ tideLevelFooterDisplay() }}
          </p>
        </div>
      </div>
    </section>

    <!-- FLOATING OVERLAY OPACITY WIDGETS -->
    <div class="overlay-widgets-container" *ngIf="activeOverlayConfigs.length > 0 && !isProfileOpen">

      <!-- COMBINED pill: both icons + shared slider when 2+ overlays are active -->
      <ng-container *ngIf="activeOverlayConfigs.length > 1">
        <div class="overlay-combined-widget">
          <!-- Stacked icons at the top -->
          <div class="overlay-icons-stack">
            <button class="overlay-icon-badge overlay-icon-btn" *ngFor="let config of activeOverlayConfigs"
              [ngClass]="config.type" [class.active]="activeOverlayWidgetType === config.type"
              (click)="activeOverlayWidgetType === config.type ? openOverlayWithSelection(config.type) : setActiveOverlayWidgetType(config.type)"
              [attr.aria-label]="'Select ' + config.type + ' overlay in widget'">
              <img *ngIf="config.type === 'chlorophyll'" src="/assets/home/overlay/chlorophyll_layer.png"
                alt="chlorophyll icon">
              <img *ngIf="config.type === 'sst'" src="/assets/home/overlay/temparature_logo.svg" alt="sst icon">
              <img *ngIf="config.type === 'wind'" src="/assets/home/overlay/wind_logo.svg" alt="weather icon">
            </button>
          </div>

          <!-- Shared vertical slider -->
          <div class="overlay-slider-track">
            <input type="range" min="0" max="100" [value]="getActiveOverlayWidgetConfig()?.opacity ?? 65"
              (input)="updateActiveOverlayWidgetOpacity(+$any($event.target).value)" class="overlay-vertical-slider"
              orient="vertical">
          </div>

          <!-- Shared percent -->
          <span class="overlay-opacity-label">{{ (getActiveOverlayWidgetConfig()?.opacity ?? 65) }}%</span>

          <!-- Close all overlays -->
          <button class="overlay-close-btn" (click)="closeAllMapOverlays()" aria-label="Close all overlays">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
              stroke-linecap="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>

          <div *ngIf="getActiveOverlayWidgetConfig()?.type === 'wind'" class="overlay-weather-bbox-control">
            <button class="overlay-weather-bbox-btn" [class.loading]="isWeatherZonesLoading"
              (click)="loadWeatherZonesFromBbox()" [disabled]="isWeatherZonesLoading"
              aria-label="Load weather zones from bbox" title="Load weather zones">
              <img *ngIf="!isWeatherZonesLoading" src="/assets/home/overlay/wind_glass.png" alt="" aria-hidden="true">
              <span *ngIf="isWeatherZonesLoading" class="overlay-weather-loader" role="status" aria-live="polite"
                aria-label="Loading weather zones"></span>
            </button>
          </div>
        </div>
      </ng-container>

      <!-- SINGLE pill: individual icon + slider when only 1 overlay is active -->
      <ng-container *ngIf="activeOverlayConfigs.length === 1">
        <div class="overlay-opacity-widget" *ngFor="let config of activeOverlayConfigs" [ngClass]="config.type">
          <button class="overlay-widget-icon overlay-icon-btn" (click)="openOverlayWithSelection(config.type)"
            [attr.aria-label]="'Open ' + config.type + ' overlay settings'">
            <img *ngIf="config.type === 'chlorophyll'" src="/assets/home/overlay/chlorophyll_layer.png"
              alt="chlorophyll icon">
            <img *ngIf="config.type === 'sst'" src="/assets/home/overlay/temparature_logo.svg" alt="sst icon">
            <img *ngIf="config.type === 'wind'" src="/assets/home/overlay/wind_logo.svg" alt="weather icon">
          </button>
          <div class="overlay-slider-track">
            <input type="range" min="0" max="100" [value]="config.opacity"
              (input)="updateOverlayOpacity(config.type, +$any($event.target).value)" class="overlay-vertical-slider"
              orient="vertical">
          </div>
          <span class="overlay-opacity-label">{{ config.opacity }}%</span>
          <button class="overlay-close-btn" (click)="closeMapOverlay(config.type)" aria-label="Close overlay">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
              stroke-linecap="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
          <div *ngIf="config.type === 'wind'" class="overlay-weather-bbox-control">
            <button class="overlay-weather-bbox-btn" [class.loading]="isWeatherZonesLoading"
              (click)="loadWeatherZonesFromBbox()" [disabled]="isWeatherZonesLoading"
              aria-label="Load weather zones from bbox" title="Load weather zones">
              <img *ngIf="!isWeatherZonesLoading" src="/assets/home/overlay/wind_glass.png" alt="" aria-hidden="true">
              <span *ngIf="isWeatherZonesLoading" class="overlay-weather-loader" role="status" aria-live="polite"
                aria-label="Loading weather zones"></span>
            </button>
          </div>
        </div>
      </ng-container>

    </div>

  </section>

  <app-trip #tripComponent></app-trip>

  <!-- RIDE ALONG follow card — shown while following a captain's live trip -->
  <div class="ride-along-follow-anchor"
    *ngIf="rideAlongFollowActive && !isProfileOpen && !isWatchOpen && !isFilterOpen && !isWaypointManagerOpen && !isReplayMode">
    <app-ride-along-follow
      [startTimeMs]="rideAlongStartTimeMs"
      [distanceMeters]="rideAlongDistanceMeters"
      [speedMs]="rideAlongSpeedMs"
      [waterTempC]="rideAlongWaterTempC"
      [latitude]="rideAlongLat"
      [longitude]="rideAlongLng"
      [paused]="rideAlongPaused"
      [distanceUnit]="rideAlongDistanceUnit"
      [temperatureUnit]="rideAlongTemperatureUnit"
      (viewMates)="openRideAlongParticipants()"
      (viewWaypoints)="openRideAlongWaypoints()">
    </app-ride-along-follow>
  </div>
</div>

<!-- RIDE ALONG incoming invitation card (always mounted; self-hides) -->
<app-ride-along-invite></app-ride-along-invite>

<!-- RIDE ALONG participants (captain + riders) -->
<app-ride-along-participants
  *ngIf="rideAlongParticipantsOpen"
  [tripId]="rideAlongParticipantsTripId"
  [participantsInput]="rideAlongParticipantsList"
  [captainVesselFallback]="rideAlongVesselName"
  (close)="closeRideAlongParticipants()">
</app-ride-along-participants>

<!-- RIDE ALONG added waypoints (mine / others) -->
<app-ride-along-waypoints
  *ngIf="rideAlongWaypointsOpen"
  [tripId]="rideAlongWaypointsTripId"
  (waypointRemoved)="onRideAlongWaypointRemoved($event)"
  (close)="closeRideAlongWaypoints()">
</app-ride-along-waypoints>
<app-waypoints *ngIf="isWaypointManagerOpen" [initialWaypointId]="activeWaypointManagerId" [hideWaypointList]="true"
  [directMode]="true" (closed)="closeWaypointManager()">
</app-waypoints>
<app-watch-page *ngIf="isWatchOpen"></app-watch-page>
<app-app-banner variant="bottom" dismissKey="vm_home_banner_dismissed"></app-app-banner>
<app-download-popup></app-download-popup>
<!-- <app-messages></app-messages> -->

<!-- Combo 5-model wind chart — full-width, non-blocking bottom sheet. Clicks
     pass through the empty area to the map so the user can keep tapping new
     spots (each tap re-runs loadWindModels; the chart auto-refreshes from the
     service). Dismiss only via the × button in the chart header. -->
<div class="combo-chart-host" *ngIf="comboShowChart">
  <div class="combo-chart-sheet">
    <app-combo-wind-chart (closeChart)="onComboCloseChart()"></app-combo-wind-chart>
  </div>
</div>

<!-- TRIP REPLAY LOADING — full-screen blocking overlay with a large centered
     spinner. Disables every interaction with the map/controls until the replay
     trips finish loading. -->
<div class="replay-loading-overlay" *ngIf="isReplayMode && replayState?.isLoading" role="status"
  aria-live="polite" aria-label="Loading trip replay">
  <div class="replay-loading-spinner" aria-hidden="true"></div>
  <span class="replay-loading-text">Loading trip replay…</span>
</div>
